const ContentManagement = () => import('@/vuepage/content/index');
const ContentBannerList = () => import('@/vuepage/content/banner-list');
const ContentBannerAdd = () => import('@/vuepage/content/banner-add');
const HomeProductCategoryList = () => import('@/vuepage/content/home-product-category-list');
const HomeProductCategoryAdd = () => import('@/vuepage/content/home-product-category-add');
const HomeBrandList = () => import('@/vuepage/content/home-brand-list');
const HomeBrandAdd = () => import('@/vuepage/content/home-brand-add');
const ContentAbout = () => import('@/vuepage/content/about');
const ContentJoinUs = () => import('@/vuepage/content/join-us');
const ContentGVRP = () => import('@/vuepage/content/gvrp');
const ContentProtocol = () => import('@/vuepage/content/protocol');
const ContentFlow = () => import('@/vuepage/content/flow');
const ContentProblemList = () => import('@/vuepage/content/problem-list');
const ContentProblemAdd = () => import('@/vuepage/content/problem-add');
const ContentProblemHotList = () => import('@/vuepage/content/hot-list');
const ContentProblemFeedbackList = () => import('@/vuepage/content/feedback-list');
const ContentProblemFeedbackDetail = () => import('@/vuepage/content/feedback-detail');
const ContentProblemConditionList = () => import('@/vuepage/content/condition-list');

export default [
  {
    path: '/content-management',
    component: ContentManagement,
    children: [
      {
        path: 'flow',
        component: ContentFlow,
        meta: [
          {
            name: '内容管理',
            url: '/content-management',
          },
          {
            name: '线下付款流程',
            url: 'flow',
          },
        ],
      },
      {
        path: 'protocol',
        component: ContentProtocol,
        meta: [
          {
            name: '内容管理',
            url: '/content-management',
          },
          {
            name: '用户协议',
            url: 'protocol',
          },
        ],
      },
      {
        path: 'condition-list',
        component: ContentProblemConditionList,
        meta: [
          {
            name: '内容管理',
            url: '/content-management',
          },
          {
            name: '条件设置',
            url: 'condition-list',
          },
        ],
      },
      {
        path: 'feedback-detail',
        component: ContentProblemFeedbackDetail,
        meta: [
          {
            name: '内容管理',
            url: '/content-management',
          },
          {
            name: '意见反馈',
            url: 'feedback-list',
          },
          {
            name: '查看详情',
            url: 'feedback-detail',
          },
        ],
      },
      {
        path: 'feedback-list',
        component: ContentProblemFeedbackList,
        meta: [
          {
            name: '内容管理',
            url: '/content-management',
          },
          {
            name: '意见反馈',
            url: 'feedback-list',
          },
        ],
      },
      {
        path: 'hot-list',
        component: ContentProblemHotList,
        meta: [
          {
            name: '内容管理',
            url: '/content-management',
          },
          {
            name: '热门搜索',
            url: 'hot-list',
          },
        ],
      },
      {
        path: 'problem-add',
        component: ContentProblemAdd,
        meta: [
          {
            name: '内容管理',
            url: '/content-management',
          },
          {
            name: '常见问题',
            url: 'problem-list',
          },
          {
            name: '新建问题',
            url: 'problem-add',
          },
        ],
      },
      {
        path: 'problem-list',
        component: ContentProblemList,
        meta: [
          {
            name: '内容管理',
            url: '/content-management',
          },
          {
            name: '常见问题',
            url: 'problem-list',
          },
        ],
      },
      {
        path: 'about',
        component: ContentAbout,
        meta: [
          {
            name: '内容管理',
            url: '/content-management',
          },
          {
            name: '关于我们',
            url: 'about',
          },
        ],
      },
      {
        path: 'banner-list',
        component: ContentBannerList,
        meta: [
          {
            name: '内容管理',
            url: '/content-management',
          },
          {
            name: '轮播图管理',
            url: 'banner-list',
          },
        ],
      },
      {
        path: 'banner-add',
        component: ContentBannerAdd,
        meta: [
          {
            name: '内容管理',
            url: '/content-management',
          },
          {
            name: '轮播图管理',
            url: 'banner-list',
          },
          {
            name: '新增/编辑轮播图',
            url: 'banner-add',
          },
        ],
      },
      {
        path: 'home-brand-list',
        component: HomeBrandList,
        meta: [
          {
            name: '内容管理',
            url: '/content-management',
          },
          {
            name: '首页品牌管理',
            url: 'home-brand-list',
          },
        ],
      },
      {
        path: 'home-brand-add',
        component: HomeBrandAdd,
        meta: [
          {
            name: '内容管理',
            url: '/content-management',
          },
          {
            name: '首页品牌管理',
            url: 'home-brand-list',
          },
          {
            name: '新增/编辑首页品牌',
            url: 'home-brand-add',
          },
        ],
      },
      {
        path: 'home-product-category-list',
        component: HomeProductCategoryList,
        meta: [
          {
            name: '内容管理',
            url: '/content-management',
          },
          {
            name: '首页分类管理',
            url: 'home-product-category-list',
          },
        ],
      },
      {
        path: 'home-product-category-add',
        component: HomeProductCategoryAdd,
        meta: [
          {
            name: '内容管理',
            url: '/content-management',
          },
          {
            name: '首页分类管理',
            url: 'home-product-category-list',
          },
          {
            name: '新增/编辑首页分类',
            url: 'home-product-category-add',
          },
        ],
      },
      {
        path: 'join-us',
        component: ContentJoinUs,
        meta: [
          {
            name: '内容管理',
            url: '/content-management',
          },
          {
            name: '加入我们',
            url: 'join-us',
          },
        ],
      },
      {
        path: 'gvrp',
        component: ContentGVRP,
        meta: [
          {
            name: '内容管理',
            url: '/content-management',
          },
          {
            name: '注册协议',
            url: 'gvrp',
          },
        ],
      },
    ],
  },
];



// WEBPACK FOOTER //
// ./src/router/content.js